module.exports = __webpack_public_path__ + "img/MenuActive.dd8a72e1.svg";